export class PackageInterest {
  accountGroupId: string;
  message: string;
  firstName: string;
  email: string;
  packageId: string;
  packageName: string;
}
